import consumer from "./consumer"

function show_update(id) {
  setTimeout(function(){
    $("#check_"+id).fadeToggle(1200,function(){ $("#updated_at_"+id).toggle(); });
  },100);
}

window.subscribe_document_channel = function subscribe_document_channel(quills, find_quills){

  var doc_id = document.getElementById('doc_id');
  if(doc_id) {
    var doc_id = document.getElementById('doc_id').innerHTML;
    consumer.subscriptions.create({
      channel: 'DocumentChannel',
      doc_id: doc_id,
    }, 
    {
      connected: function() {
        // Called when the subscription is ready for use on the server
      },

      disconnected: function() {
        // Called when the subscription has been terminated by the server
      },

      received: function(data) {
        $("#attn_"+data.id).fadeOut();
        var cnt1;
        var id;
        var src;
        var src_split;
        var src_split_html;
        var targ;
        var name;
        var timestamp;
        var targ_changed;
        var text;
        for (let cnt=0; cnt < data.array.length; cnt++) { 
          id = data.array[cnt][0];
          src = data.array[cnt][1];
          src_split = data.array[cnt][2];
          targ = data.array[cnt][3];
          name = data.array[cnt][4];
          timestamp = data.array[cnt][5];
          targ_changed = data.array[cnt][6];
          text = replace_punctuation(targ);

          if ( $("#row_"+id).length ){

            if (quills[id]){quills[id].setText(text);}
            if (find_quills[id]){find_quills[id].setText(text);}  

            $("#row_"+id+" > #source > #source_text")[0].innerHTML = src;

            src_split_html = ''
            for (cnt1=0; cnt1 < src_split.length; cnt1++) {
              src_split_html += "<span class='underline-"+(cnt1%3).toString()+"'><p>"+src_split[cnt1]+"</p></span>"
            }
            $("#row_"+id+" > #source > #source_text_broken")[0].innerHTML = src_split_html;

            //console.log(id);
            //console.log($("#tm_"+id));
            $("#tm_"+id)[0].innerHTML = "<span style='' class='badge badge-blue'>"+name+"</span>";
            $("#attn_"+id)[0].innerHTML = '';
            $("#check_"+id).toggle();
            $("#updated_at_"+id).toggle();
            $("#updated_at_"+id).html("<small>"+timestamp+"</small>")
            targ_changed && $(".number-mismatch[data-id="+id+"]").fadeOut();
            targ_changed && $(".punctuation-mismatch[data-id="+id+"]").fadeOut();
  
            show_update(id);
          }
        } 
        
        for (let cnt=0; cnt < data.remove_array.length; cnt++) {
          if ( $("#row_"+data.remove_array[cnt].id).length ){     
            $("#row_"+data.remove_array[cnt].id).hide();
          }
        }         
        
      },
    });
  }
}
